import React from 'react';
import { startCase } from 'lodash';

import CSRFForm from '@reverbdotcom/commons/src/csrf_form';
import FormGroupWithInput from '@reverbdotcom/commons/src/components/form_group_with_input';
import FormGroupWithSelect from '@reverbdotcom/commons/src/components/form_group_with_select';

interface BrazeMailer {
  class: {};
  optional_params?: string[];
}

interface BrazeMailers {
  [key: string]: BrazeMailer;
}

interface IProps {
  brazeMailers: BrazeMailers;
}

export default function AdminBrazeEmailPreviewForm({ brazeMailers }: IProps) {
  const [emailName, setEmailName] = React.useState('');
  const [optionalInputValues, setOptionalInputValues] = React.useState({});
  const optionalInputs = brazeMailers[emailName]?.optional_params;

  function selectFields() {
    return Object.keys(brazeMailers).map(mailerName => ({
      text: mailerName,
      value: mailerName,
    }));
  }

  function initialOptionalInputValues(mailerName) {
    const optionalParams = brazeMailers[mailerName]?.optional_params;

    if (optionalParams) {
      return optionalParams.reduce((acc, optionalInput) => {
        acc[optionalInput] = '';
        return acc;
      }, {});
    }

    return {};
  }

  return (
    <div className="width-75 mtb-3">
      <CSRFForm
        method="POST"
        action="/admin/braze_trigger_preview_emails"
      >
        <FormGroupWithSelect
          inputName="braze_email_name"
          label="Braze Email"
          options={selectFields()}
          value={emailName}
          updateField={
            (fieldUpdate) => {
              setEmailName(fieldUpdate.braze_email_name);
              setOptionalInputValues(initialOptionalInputValues(fieldUpdate.braze_email_name));
            }
          }
          addEmptyOption
          required
          tagRequired
        />

        {!!optionalInputs && (
          optionalInputs.map(optionalInput => (
            <FormGroupWithInput
              key={optionalInput}
              inputName={optionalInput}
              label={startCase(optionalInput)}
              value={optionalInputValues[optionalInput]}
              updateField={
                (fieldUpdate) => {
                  setOptionalInputValues({ ...optionalInputValues, ...fieldUpdate });
                }
              }
              tagOptional
            />
          ))
        )}

        <button
          className="button button--primary"
          type="submit"
          value="Submit"
        >
          Submit
        </button>
      </CSRFForm>
    </div>
  );
}
